module.exports = __webpack_public_path__ + "static/media/dispepsia-faq.e88c0b0d.jpg";